var _path, _path2, _g, _path3, _path4, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIncrementIconWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7068 30.7395L18.6155 30.642V21.3921H9.37483C9.32219 21.3921 9.27832 21.3483 9.27832 21.2947V18.7163C9.27832 18.6628 9.32219 18.6189 9.37483 18.6189H18.6155V9.34091C18.6155 9.30405 18.6454 9.27422 18.6831 9.27422L21.3276 9.27509L21.3942 9.34091V18.6189H30.6244C30.6849 18.6189 30.735 18.6689 30.735 18.7295V21.2886L30.6244 21.4H21.3942V30.6499C21.3942 30.7008 21.353 30.7421 21.3021 30.7421L18.7068 30.7395Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6083_3792",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H40V40H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6083_3792)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0038 2.6302C12.9557 2.6302 6.65782 6.83917 3.95984 13.3527C1.26186 19.8672 2.73938 27.2978 7.72385 32.2843C11.0035 35.5648 15.3668 37.3727 20.0082 37.3727H20.0091C22.2973 37.3727 24.5321 36.9277 26.6501 36.0501C33.163 33.3524 37.3709 27.053 37.3709 20.0014C37.3604 10.5269 29.7192 2.79256 20.2802 2.63371L20.0038 2.6302ZM20.0062 40.0002C11.8904 40.0002 4.63871 35.1541 1.53186 27.6541C-1.57411 20.1541 0.128033 11.5984 5.86706 5.85799C9.64336 2.08079 14.6656 0 20.0089 0C22.6446 0 25.2171 0.512519 27.6571 1.52352C35.1553 4.63022 40.0003 11.8827 40.0003 20.0014C39.9862 31.0153 31.0175 39.987 20.0054 40.0002H20.0062Z",
    fill: "white"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7068 30.7395L18.6155 30.642V21.3921H9.37483C9.32219 21.3921 9.27832 21.3483 9.27832 21.2947V18.7163C9.27832 18.6628 9.32219 18.6189 9.37483 18.6189H18.6155V9.34091C18.6155 9.30405 18.6454 9.27422 18.6831 9.27422L21.3276 9.27509L21.3942 9.34091V18.6189H30.6244C30.6849 18.6189 30.735 18.6689 30.735 18.7295V21.2886L30.6244 21.4H21.3942V30.6499C21.3942 30.7008 21.353 30.7421 21.3021 30.7421L18.7068 30.7395Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_6083_3792",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H40V40H0V0Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_6083_3792)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0038 2.6302C12.9557 2.6302 6.65782 6.83917 3.95984 13.3527C1.26186 19.8672 2.73938 27.2978 7.72385 32.2843C11.0035 35.5648 15.3668 37.3727 20.0082 37.3727H20.0091C22.2973 37.3727 24.5321 36.9277 26.6501 36.0501C33.163 33.3524 37.3709 27.053 37.3709 20.0014C37.3604 10.5269 29.7192 2.79256 20.2802 2.63371L20.0038 2.6302ZM20.0062 40.0002C11.8904 40.0002 4.63871 35.1541 1.53186 27.6541C-1.57411 20.1541 0.128033 11.5984 5.86706 5.85799C9.64336 2.08079 14.6656 0 20.0089 0C22.6446 0 25.2171 0.512519 27.6571 1.52352C35.1553 4.63022 40.0003 11.8827 40.0003 20.0014C39.9862 31.0153 31.0175 39.987 20.0054 40.0002H20.0062Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncrementIconWhite);
export default __webpack_public_path__ + "static/media/increment-icon-white.42eb39278b8c1dc25bdebbc2e5f62303.svg";
export { ForwardRef as ReactComponent };